import * as Diagram from "../../../../components/diagram";
import { formatLevelColumns } from "../../../fromatApiRes";

const levelColumns = [
  {
    key: "Quantity",
    isNumber: true,
    isHide: true,
  },
];

export const HighRiskFactorStatistics = {
  label: "高風險因子統計",
  key: "HighRiskFactorStatistics",
  path: "BoneMuscleCare/HighRiskFactorStatistics",
  api: "TCS_V_HighRisk01V",
  render: (options) => (
    <Diagram.BoneMuscleCare.HighRiskFactorStatistics {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "高風險因子",
      field: "高風險因子",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
